export default __webpack_public_path__ + "6bcd0726539f918e441a630eaec288b3.png";